module.exports = __webpack_public_path__ + "static/media/stat547u_pset01_instructions.b225090d.pdf";